var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { allowedToSelfWithdraw } from '../../../../../backend/utils/allowedToSelfWithdraw';
import { useMissionsTranslation } from '../../../../../ui/hooks';
import { showFormDialog } from '@juvare/common-form-ui/showFormDialog';
import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import { getSettings } from '@juvare/platform-sdk-react/ui/features/editable-settings';
import DoNotDisturbIcon from '@mui/icons-material/DoNotDisturb';
import { Box, Button, Tooltip, Typography } from '@mui/material';
import { hoursToMilliseconds } from 'date-fns';
import React from 'react';
import { useSelector } from 'react-redux';
export const ShiftDetailsVolunteerActions = ({ participationStatus, shiftStopTime, shiftStartTime, onRequest, onParticipantSelfWithdrawal, }) => {
    const { t } = useMissionsTranslation();
    const isUpcomingShift = shiftStopTime > Date.now();
    const settings = useSelector(getSettings);
    const allowSelfWithdrawalTimeMs = hoursToMilliseconds(settings.allowSelfWithdrawalTime.time);
    const allowSelfWithdraw = (shiftStartTimeMs) => allowedToSelfWithdraw(shiftStartTimeMs, allowSelfWithdrawalTimeMs);
    let actions = null;
    const handleWithdraw = () => {
        showFormDialog({
            title: t('shifts.pendingRequest.withdrawShift.toolbarSelfWithdrawalConfirmationTitle'),
            config: {
                type: 'form',
                children: [
                    {
                        type: 'form.content',
                        html: `<p class="body1">${t('shifts.pendingRequest.withdrawShift.toolbarSelfWithdrawalConfirmationContent')}</p>`,
                    },
                ],
            },
            onSubmit: () => __awaiter(void 0, void 0, void 0, function* () {
                onParticipantSelfWithdrawal();
            }),
            submitLabel: t('missions.missionDetails.withdraw'),
        });
    };
    const getActionsByParticipationStatus = () => {
        if (['approved', 'pending'].includes(participationStatus !== null && participationStatus !== void 0 ? participationStatus : '') && isUpcomingShift) {
            if (allowSelfWithdraw(shiftStartTime)) {
                return (React.createElement(Button, { onClick: (e) => {
                        e.stopPropagation();
                        handleWithdraw();
                    }, "data-test": 'withdraw-button', variant: 'outlined' }, t('missions.missionDetails.withdraw')));
            }
            else {
                return (React.createElement(Tooltip, { enterTouchDelay: 0, title: t('missions.missionDetails.withdrawDisabledTooltip', {
                        selfWithdrawalAllowedTimeHr: settings.allowSelfWithdrawalTime.time,
                    }), placement: 'bottom', "data-test": 'withdraw-status-tooltip', tabIndex: 0, onClick: (e) => e.stopPropagation() },
                    React.createElement("span", null,
                        React.createElement(Button, { disabled: true, "data-test": 'withdraw-button', variant: 'outlined' }, t('missions.missionDetails.withdraw')))));
            }
        }
        let tooltipTitle = '';
        if (participationStatus === 'deniedRosterFull') {
            tooltipTitle = t('shifts.pendingRequest.denyShift.fullRosterTooltip');
        }
        if (participationStatus === 'deniedNotQualified') {
            tooltipTitle = t('shifts.pendingRequest.denyShift.notQualifiedTooltip');
        }
        if (tooltipTitle) {
            return (React.createElement(Box, { display: 'flex', sx: { gap: 1, pl: 1.5, alignItems: 'center', color: themeColors.text.subtle } },
                React.createElement(Tooltip, { enterTouchDelay: 0, title: tooltipTitle, placement: 'bottom', "data-test": 'request-status-tooltip' },
                    React.createElement(DoNotDisturbIcon, { fontSize: 'small', sx: { color: themeColors.text.subtle } })),
                React.createElement(Typography, { variant: 'body2' }, t('common.denied'))));
        }
        return null;
    };
    if (participationStatus) {
        actions = getActionsByParticipationStatus();
    }
    else if (isUpcomingShift) {
        actions = (React.createElement(Button, { variant: 'outlined', sx: { zIndex: 1 }, onClick: (e) => {
                e.stopPropagation();
                onRequest();
            }, "data-test": 'request-shift-button' }, t('missions.missionDetails.requestShiftButton')));
    }
    return actions;
};
